var map = {
	"./france.png": "1ad9",
	"./italy.png": "512a",
	"./united_kingdom.png": "ec43",
	"./united_states.png": "a4ea7",
	"./united_states_spanish.png": "3669",
	"./xxxx.png": "f163"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "587d";